// removed by extract-text-webpack-plugin
module.exports = {"component":"_1Pix-cfAcFsQg9w3jffXoJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Sidebar/sidebar.css
// module id = 447
// module chunks = 2